import { get } from "lodash";
import moment from "moment";
import { isPlanOutsideRetroactivityWindow } from "screens/Private/Broker/Projects/Detail/Templates/Manual/AcorisConseiller/retroactivity";
import { INSURANCE_PLAN_PARAMS_RULES } from "utils/constants";
import Card from "./Card";

const InsurancePlans = ({
  insurancePlan,
  cost,
  currency,
  translation,
  subscriptions = [],
  onSubscribe,
  subscribeLoadingId,
  issuanceDate,
  isRIA,
  expired: projectExpired,
  locked,
  selectedModules,
  setSelectedModules,
  project,
}) => {
  const subscription = subscriptions.find(
    (subscription) =>
      get(subscription, "insurancePlan.id") === insurancePlan.id,
  );
  const expired =
    projectExpired ||
    (project.retroactive
      ? isPlanOutsideRetroactivityWindow({ insurancePlan, issuanceDate })
      : get(insurancePlan, "params", []).some((param) => {
          return (
            moment(issuanceDate)
              .startOf("day")
              .diff(moment().startOf("day"), "days") <
            get(param, "rules", []).find(
              ({ name }) =>
                name ===
                (isRIA
                  ? INSURANCE_PLAN_PARAMS_RULES.DELTA_START_RIA
                  : INSURANCE_PLAN_PARAMS_RULES.DELTA_START),
            )?.value
          );
        }));

  const isSubscribeLoading =
    !!subscribeLoadingId && subscribeLoadingId === subscription?.id;
  const isAnySubscribeLoading = !!subscribeLoadingId;

  return (
    <Card
      key={insurancePlan.id}
      insurancePlan={insurancePlan}
      cost={cost}
      currency={currency}
      period={translation.MONTH}
      popover={{
        active: subscription && expired,
        text: translation.POPOVER,
      }}
      action={{
        label: translation.SUBSCRIPTION,
        onClick: () => {
          if (!subscription || expired || isAnySubscribeLoading) return;
          onSubscribe({
            actionsTemplate: {
              id: subscription?.id,
              status: subscription?.status,
            },
          });
        },
        disabled: !subscription || expired || isAnySubscribeLoading,
        loading: isSubscribeLoading,
      }}
      selectedModules={selectedModules}
      setSelectedModules={setSelectedModules}
      translation={translation}
      project={project}
    />
  );
};

export default InsurancePlans;
